import { jsx as _jsx } from "react/jsx-runtime";
import { useRef } from 'react';
import { CSSTransition } from 'react-transition-group';
import clsx from 'clsx';
import { createNamespace, isDef, preventDefault, withStopPropagation } from '../utils';
import { useEventListener } from '../hooks';
import { mergeProps } from '../utils/get-default-props';
const [bem] = createNamespace('overlay');
const Overlay = p => {
  const nodeRef = useRef(null);
  const props = mergeProps(p, {
    stopPropagation: ['click'],
    lockScroll: true,
    duration: 300
  });
  const {
    visible,
    duration
  } = props;
  const preventTouchMove = event => {
    if (!props.lockScroll) return;
    preventDefault(event, true);
  };
  const renderOverlay = () => {
    const style = Object.assign(Object.assign({
      zIndex: props.zIndex !== undefined ? +props.zIndex : undefined,
      touchAction: props.lockScroll && 'none'
    }, props.style), props.customStyle);
    if (isDef(duration)) {
      style.animationDuration = `${duration}ms`;
    }
    return withStopPropagation(props.stopPropagation, _jsx("div", Object.assign({
      ref: nodeRef,
      style: style,
      onClick: e => {
        var _a;
        if (e.target === e.currentTarget) {
          (_a = props.onClick) === null || _a === void 0 ? void 0 : _a.call(props, e);
        }
      },
      className: clsx(bem(), props.className)
    }, {
      children: props.children
    })));
  };
  useEventListener('touchmove', preventTouchMove, {
    target: nodeRef
  });
  return _jsx(CSSTransition, Object.assign({
    nodeRef: nodeRef,
    mountOnEnter: true,
    unmountOnExit: true,
    in: visible,
    timeout: duration,
    classNames: 'rv-fade'
  }, {
    children: renderOverlay()
  }));
};
export default Overlay;